// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cd61bb12","229":"d0b49daf","289":"2c15bbbb","359":"e099e117","495":"19cccf8c","516":"4a5d92a0","588":"13fab1a0","667":"e77d1ffb","721":"4872aaaf","737":"e7ce59d7","858":"3cf1c606","965":"1e8b08b1","974":"2dd76070"}[chunkId] + ".chunk.js";
};